import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=5fc07ecf&scoped=true&"
import script from "./FileRow.vue?vue&type=script&lang=js&"
export * from "./FileRow.vue?vue&type=script&lang=js&"
import style0 from "./FileRow.vue?vue&type=style&index=0&id=5fc07ecf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc07ecf",
  null
  
)

export default component.exports